export enum RoutePaths {
  HOME = "/",
  CAREER = "/career",
  PRODUCTS = "/products",
  ABOUT = "/about",
  CONTACT = "/contact",
  BLOG = "/blog",
  SICHERO = "/products/sichero",
  SEARCH_AGENT = "/products/search_agent",
  DYNAMIC_PRICING = "/products/dynamic_pricing",
  SALES_AGENT = "/products/sales_agent",
  ABOUT_CAREER = "/career/:careerId",
  ABOUT_BLOG = "/blog/:blogId",
  ADMIN = "/admin",
  LOGIN = "/login",
  ADD_CAREER = "/admin/career",
  ADD_BLOG = "/admin/blog",
  PRIVACY_POLICY = "/privacy_policy",
}
